define('modules/editor/views/propertybox',['require','exports','module','base/class','../models/property_groups/size','../models/property_groups/idclass','../models/property_groups/geometry','../models/property_groups/section_geometry','../models/property_groups/text_content','../models/property_groups/border','../models/property_groups/background','../models/property_groups/html_content','../models/property_groups/form_geometry','../models/property_groups/form_content','../models/property_groups/form_submit_format','../models/property_groups/form_input_format','../models/property_groups/form_label','../models/property_groups/form_radio_format','../models/property_groups/action','../models/property_groups/label','../models/property_groups/button_style','../models/property_groups/button_geometry','../models/property_groups/custom_amp_script','../models/property_groups/video_content','../models/property_groups/image_content','../models/property_groups/page_defaults','../models/property_groups/page_popup','../models/property_groups/page_confirmation','../models/property_groups/page_privacy','../models/property_groups/page_notification','../models/property_groups/page_conversion','../models/property_groups/page_jquery_selector','../models/property_groups/page_gtm','../models/property_groups/social_facebook','../models/property_groups/social_twitter','../models/property_groups/social_google','./property_boxes/size','./property_boxes/idclass','./property_boxes/geometry','./property_boxes/section_geometry','./property_boxes/text_content','./property_boxes/border','./property_boxes/background','./property_boxes/html_content','./property_boxes/form_geometry','./property_boxes/form_content','./property_boxes/form_submit_format','./property_boxes/form_input_format','./property_boxes/form_label','./property_boxes/form_radio_format','./property_boxes/action','./property_boxes/label','./property_boxes/button_style','./property_boxes/button_geometry','./property_boxes/form_custom_amp_script','./property_boxes/video_content','./property_boxes/image_content','./property_boxes/page_defaults','./property_boxes/page_popup','./property_boxes/page_confirmation','./property_boxes/page_privacy','./property_boxes/page_notification','./property_boxes/page_conversion','./property_boxes/page_jquery_selector','./property_boxes/page_gtm','./property_boxes/social_facebook','./property_boxes/social_twitter','./property_boxes/social_google'],function(require, exports, module) {
  "use strict";

  var Class = require('base/class');

  /* PROPERTY GROUPS */
  var SizePropertyGroup = require('../models/property_groups/size'),
      IdClassPropertyGroup = require('../models/property_groups/idclass'),
      GeometryPropertyGroup = require('../models/property_groups/geometry'),
      SectionGeometryPropertyGroup = require('../models/property_groups/section_geometry'),
      TextContentPropertyGroup = require('../models/property_groups/text_content'),
      BorderPropertyGroup = require('../models/property_groups/border'),
      BackgroundPropertyGroup = require('../models/property_groups/background'),
      HtmlContentPropertyGroup = require('../models/property_groups/html_content'),

      //form
      FormGeometryPropertyGroup = require('../models/property_groups/form_geometry'),
      FormContentPropertyGroup = require('../models/property_groups/form_content'),
      FormSubmitFormatPropertyGroup = require('../models/property_groups/form_submit_format'),
      FormInputFormatPropertyGroup = require('../models/property_groups/form_input_format'),
      FormLabelPropertyGroup = require('../models/property_groups/form_label'),
      FormRadioFormatPropertyGroup = require('../models/property_groups/form_radio_format'),
      ActionPropertyGroup = require('../models/property_groups/action'),
      LabelPropertyGroup = require('../models/property_groups/label'),
      ButtonStylePropertyGroup = require('../models/property_groups/button_style'),
      ButtonGeometryPropertyGroup = require('../models/property_groups/button_geometry'),
      CustomAMPFormScriptGroup = require('../models/property_groups/custom_amp_script'),

      //video
      VideoContentPropertyGroup = require('../models/property_groups/video_content'),

      //imagen
      ImageContentPropertyGroup = require('../models/property_groups/image_content'),

      //page
      PageDefaultsPropertyGroup = require('../models/property_groups/page_defaults'),
      PagePopupPropertyGroup = require('../models/property_groups/page_popup'),
      PageConfirmationPropertyGroup = require('../models/property_groups/page_confirmation'),
      PagePrivacyPropertyGroup = require('../models/property_groups/page_privacy'),
      PageNotificationPropertyGroup = require('../models/property_groups/page_notification'),
      PageConversionPropertyGroup = require('../models/property_groups/page_conversion'),
      PageJQuerySelectorPropertyGroup = require('../models/property_groups/page_jquery_selector'),
      PageGTMPropertyGroup = require('../models/property_groups/page_gtm'),

      //social
      SocialFacebookPropertyGroup = require('../models/property_groups/social_facebook'),
      SocialTwitterPropertyGroup = require('../models/property_groups/social_twitter'),
      SocialGooglePropertyGroup = require('../models/property_groups/social_google');

  /* PROPERTY BOXES */
  var SizePropertyBox = require('./property_boxes/size'),
      IdClassPropertyBox = require('./property_boxes/idclass'),
      GeometryPropertyBox = require('./property_boxes/geometry'),
      SectionGeometryPropertyBox = require('./property_boxes/section_geometry'),
      TextContentPropertyBox = require('./property_boxes/text_content'),
      BorderPropertyBox = require('./property_boxes/border'),
      BackgroundPropertyBox = require('./property_boxes/background'),
      HtmlPropertyBox = require('./property_boxes/html_content'),

      //form
      FormGeometryPropertyBox = require('./property_boxes/form_geometry'),
      FormContentPropertyBox = require('./property_boxes/form_content'),
      FormSubmitFormatPropertyBox = require('./property_boxes/form_submit_format'),
      FormInputFormatPropertyBox = require('./property_boxes/form_input_format'),
      FormLabelPropertyBox = require('./property_boxes/form_label'),
      FormRadioFormatPropertyBox = require('./property_boxes/form_radio_format'),
      ActionPropertyBox = require('./property_boxes/action'),
      LabelPropertyBox = require('./property_boxes/label'),
      ButtonStylePropertyBox = require('./property_boxes/button_style'),
      ButtonGeometryPropertyBox = require('./property_boxes/button_geometry'),
      CustomAMPFormScriptBox = require('./property_boxes/form_custom_amp_script'),

      //video
      VideoContentPropertyBox = require('./property_boxes/video_content'),

      //imagen
      ImageContentPropertyBox = require('./property_boxes/image_content'),

      //page
      PageDefaultsPropertyBox = require('./property_boxes/page_defaults'),
      PagePopupPropertyBox = require('./property_boxes/page_popup'),
      PageConfirmationPropertyBox = require('./property_boxes/page_confirmation'),
      PagePrivacyPropertyBox = require('./property_boxes/page_privacy'),
      PageNotificationPropertyBox = require('./property_boxes/page_notification'),
      PageConversionPropertyBox = require('./property_boxes/page_conversion'),
      PageJQuerySelectorPropertyBox = require('./property_boxes/page_jquery_selector'),
      PageGTMPropertyBox = require('./property_boxes/page_gtm'),

      //social
      SocialFacebookPropertyBox = require('./property_boxes/social_facebook'),
      SocialTwitterPropertyBox = require('./property_boxes/social_twitter'),
      SocialGooglePropertyBox = require('./property_boxes/social_google');


  module.exports = Class.extend({
    constructor: function(options) {
      switch(options.model.constructor) {
        case SizePropertyGroup:
          return new SizePropertyBox(options);
        case IdClassPropertyGroup:
          return new IdClassPropertyBox(options);
        case SectionGeometryPropertyGroup:
          return new SectionGeometryPropertyBox(options);
        case GeometryPropertyGroup:
          return new GeometryPropertyBox(options);
        case TextContentPropertyGroup:
          return new TextContentPropertyBox(options);
        case HtmlContentPropertyGroup:
          return new HtmlPropertyBox(options);
        case BorderPropertyGroup:
          return new BorderPropertyBox(options);
        case BackgroundPropertyGroup:
          return new BackgroundPropertyBox(options);

        //form
        case FormGeometryPropertyGroup:
          return new FormGeometryPropertyBox(options);
        case FormContentPropertyGroup:
          return new FormContentPropertyBox(options);
        case FormSubmitFormatPropertyGroup:
          return new FormSubmitFormatPropertyBox(options);
        case FormInputFormatPropertyGroup:
          return new FormInputFormatPropertyBox(options);
        case FormLabelPropertyGroup:
          return new FormLabelPropertyBox(options);
        case FormRadioFormatPropertyGroup:
          return new FormRadioFormatPropertyBox(options);
        case CustomAMPFormScriptGroup:
          return new CustomAMPFormScriptBox(options);
        case ActionPropertyGroup:
          return new ActionPropertyBox(options);
        case LabelPropertyGroup:
          return new LabelPropertyBox(options);
        case ButtonStylePropertyGroup:
          return new ButtonStylePropertyBox(options);
        case ButtonGeometryPropertyGroup:
          return new ButtonGeometryPropertyBox(options);
        case VideoContentPropertyGroup:
          return new VideoContentPropertyBox(options);
        case ImageContentPropertyGroup:
          return new ImageContentPropertyBox(options);
        case PageDefaultsPropertyGroup:
          return new PageDefaultsPropertyBox(options);
        case PagePopupPropertyGroup:
          return new PagePopupPropertyBox(options);
        case PageConfirmationPropertyGroup:
          return new PageConfirmationPropertyBox(options);
        case PagePrivacyPropertyGroup:
          return new PagePrivacyPropertyBox(options);
        case PageNotificationPropertyGroup:
            return new PageNotificationPropertyBox(options);
        case PageConversionPropertyGroup:
          return new PageConversionPropertyBox(options);
        case PageJQuerySelectorPropertyGroup:
          return new PageJQuerySelectorPropertyBox(options);
        case PageGTMPropertyGroup:
          return new PageGTMPropertyBox(options);
        case SocialFacebookPropertyGroup:
          return new SocialFacebookPropertyBox(options);
        case SocialTwitterPropertyGroup:
          return new SocialTwitterPropertyBox(options);
        case SocialGooglePropertyGroup:
          return new SocialGooglePropertyBox(options);
      }
    }
  });

});

